"use client";

import React from "react";
import { CircleCheck, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function BecomeAPartner() {
  const {
    ref: sectionRef,
    isVisible: isSectionVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const benefits = ["Additional income for venue owners", "Increase foot traffic and customer engagement", "Real-time station tracking and management", "Flexible partnership options for various venue types"];
  return <section id="word-een-zapgo-partner" className="relative overflow-hidden bg-background py-16 md:py-24 lg:py-32" ref={sectionRef}>
      {}
      <div className="pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_bottom_left,var(--color-primary)_0%,transparent_50%)] opacity-10 dark:opacity-20" />

      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16 items-center">
          
          {}
          <div className={`relative mx-auto w-full max-w-md lg:max-w-none transition-all duration-1000 ease-out ${isSectionVisible ? "translate-x-0 opacity-100" : "-translate-x-12 opacity-0"}`}>
            <div className="relative aspect-[4/5] w-full overflow-hidden rounded-3xl shadow-2xl ring-1 ring-border/50">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1586523/img/zapgo_station_trendy_cafe.png" alt="ZapGO! charging station in a modern cafe" className="h-full w-full object-cover transition-transform duration-700 hover:scale-105" />
              {}
              <div className="absolute -inset-4 -z-10 rounded-[3rem] bg-primary/20 blur-3xl" />
            </div>
          </div>

          {}
          <div className={`flex flex-col items-start transition-all duration-1000 delay-200 ease-out ${isSectionVisible ? "translate-x-0 opacity-100" : "translate-x-12 opacity-0"}`}>
            <Badge variant="secondary" className="mb-6 px-3 py-1 text-sm">
              Partner Program
            </Badge>
            
            <h2 className="mb-6 text-4xl font-bold tracking-tight text-foreground sm:text-5xl lg:text-6xl">
              Become a <span style={{
              color: "#ffe838"
            }}>Zap</span><span style={{
              color: "#70cf70"
            }}>GO!</span> Partner
            </h2>
            
            <p className="mb-8 text-lg text-muted-foreground sm:text-xl">
              Transform your venue into a charging hub. Offer your customers the ultimate convenience while generating extra revenue with zero hassle.
            </p>

            <ul className="mb-10 flex flex-col gap-4">
              {benefits.map((benefit, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                  <CircleCheck className="mt-1 h-6 w-6 shrink-0 text-primary" />
                  <span className="text-base text-foreground sm:text-lg">
                    {benefit}
                  </span>
                </li>)}
            </ul>

            <Button asChild size="lg" className="group h-14 px-8 text-base">
              <Link to="/PartnersPage">&nbsp;Vraag nu aan !</Link>
            </Button>
          </div>
          
        </div>
      </div>
    </section>;
}